/**
 * @file: useUniqueSvgElementId.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */
import { nanoid } from 'nanoid/non-secure';
import { useRef } from 'react';

export const useUniqueSvgElementId = () => {
  const id = useRef(nanoid(32)).current;
  const href = `url(#${id})`;
  return [id, href] as const;
};
